import {callAPI} from "./apiWrapper";
import { getDeviceInfo } from '../lib/deviceInfo';

export const updateParticipantFromClient = async (queryParamas, landingURL) => {
    let allqueryParmas = queryParamas + "&landingURL=" + encodeURIComponent(landingURL);
    
    // Add user status (KEEP ORIGINAL VALUE - different in each app)
    allqueryParmas = allqueryParmas + "&userStatus=3";
    
    // Add device information
    const deviceInfo = await getDeviceInfo();
    allqueryParmas = allqueryParmas + "&" + new URLSearchParams(deviceInfo).toString();

    return callAPI("GET", "updateParticipantFromClient/?", allqueryParmas, {}).then((result) => {
        return result;
    });
}

